var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskConfig),expression:"maskConfig"}],attrs:{"lang":"pt-BR"},domProps:{"value":_vm.innerValue},on:{"blur":_vm.onBlur,"keydown":_vm.onKeyDown,"change":_vm.updateValue,"keyup":($event) => {
    _vm.updateValue($event);
    _vm.onkeyup($event);
    }}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }